import React from "react";
import { Box, useTheme } from "@mui/material";
import logo from "../assets/images/logo.png";

const PageLoader = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        height: "100vh",
        backgroundColor: theme.palette.primary.main,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "& img": {
          animation: "bounce 0.8s ease-in-out infinite",
        },
        "@keyframes bounce": {
          "0%, 100%": {
            transform: "translateY(0)",
          },
          "50%": {
            transform: "translateY(-30px)",
          },
        },
      }}
    >
      <img width="250px" src={logo} alt="Logo" />
    </Box>
  );
};

export default PageLoader;
